/**
 * BackButton.tsx
 * Created: 2024-03-20
 * Purpose: Standardized back button component used across educational pages
 */

import React from 'react';
import styled from 'styled-components';
import { educationalPageStyles } from '../../context/EducationalPageRules';

interface BackButtonProps {
  onClick: () => void;
  top?: string;
  left?: string;
}

const StyledBackButton = styled.button<{ top?: string; left?: string }>`
  position: fixed;
  top: ${props => props.top || '120px'};
  left: ${props => props.left || '2rem'};
  padding: 0.75rem 1.5rem;
  background: ${educationalPageStyles.colors.primary};
  color: ${educationalPageStyles.colors.text};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  z-index: 2;
  transition: ${props => props.theme.transitions?.default || 'all 0.2s ease'};

  &:hover {
    background: ${educationalPageStyles.colors.hover};
  }
`;

const BackButton: React.FC<BackButtonProps> = ({ onClick, top, left }) => {
  return (
    <StyledBackButton onClick={onClick} top={top} left={left}>
      ← Back
    </StyledBackButton>
  );
};

export default BackButton; 